import React from 'react';
import './AppDownloadModal.css';

const AppDownloadModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>×</button>
        
        <div className="modal-body">
          {/* <div className="discount-badge">
            <span className="discount-text">10% OFF</span>
          </div> */}
          <h2>Download our app to book tickets</h2>
          <p>Get the best experience with our mobile app</p>
          
          <div className="store-buttons">
            <a 
              href="https://play.google.com/store/apps/details?id=com.fusshn.fusshncustomer&pcampaignid=web_share" 
              target="_blank" 
              rel="noopener noreferrer"
              className="store-button play-store"
            >
              <img 
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Google_Play_Store_badge_EN.svg/2560px-Google_Play_Store_badge_EN.svg.png" 
                alt="Get it on Google Play"
                className="store-icon"
              />
            </a>
            <a 
              href="https://apps.apple.com/in/app/fusshn-ticket-to-convenience/id6745167053" 
              target="_blank" 
              rel="noopener noreferrer"
              className="store-button app-store"
            >
              <img 
                src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" 
                alt="Download on the App Store"
                className="store-icon"
              />
            </a>
          </div>
          
          {/* <div className="features">
            <div className="feature">
              <span className="feature-icon">🎫</span>
              <span>Easy ticket booking</span>
            </div>
            <div className="feature">
              <span className="feature-icon">⚡</span>
              <span>Instant confirmation</span>
            </div>
            <div className="feature">
              <span className="feature-icon">🎯</span>
              <span>Exclusive offers</span>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default AppDownloadModal; 